module.exports = __webpack_public_path__ + "static/media/photo-3.3e56157f.jpg";